import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Routes } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-go-to-menu',
  templateUrl: './go-to-menu.component.html',
  styleUrls: ['./go-to-menu.component.scss'],
})
export class GoToMenuComponent implements OnInit {
  // add local reference to enum for html availability
  ScreenSize = ScreenSize;
  navRoutes: any[] = [];
  AccessObject: UserAccessRole | null;
  userHasWriteAccess: boolean = false;

  constructor(
    public titleService: TitleService,
    public navigationService: NavigationService,
    public layoutService: LayoutService,
    private routes: Routes,
    private auth: UserRightsService,
    private dialogRef: MatDialogRef<GoToMenuComponent>,
  ) {}

  ngOnInit() {
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (!this.AccessObject) {
      return;
    }

    this.navRoutes.push({
      title: 'Home',
      link: this.routes.Home,
      icon: 'home',
    });

    if (this.AccessObject.HasCDRAccess() && this.auth.HasCDRAccess()) {
      this.navRoutes.push({
        title: 'Data Usage',
        link: this.routes.CDR,
        customIcon: true,
        icon: 'assets/icon/barAndLineChart',
      });
    }

    if (this.AccessObject.HasKeepAliveAccess() && this.auth.HasKeepAliveAccess()) {
      this.navRoutes.push({
        title: 'Keep Alive',
        link: this.routes.KeepAlive,
        customIcon: true,
        icon: 'assets/icon/mapLocation',
      });
    }

    if (this.AccessObject.HasMikrotikAccess() && this.auth.HasMikrotikAccess()) {
      this.navRoutes.push({
        title: 'Router Management',
        link: this.routes.Mikrotik,
        customIcon: true,
        icon: 'assets/icon/routerAndCable',
      });
    }

    if (this.AccessObject.IsReporting()) {
      this.navRoutes.push({
        title: 'Reports',
        link: this.routes.Reports,
        customIcon: true,
        icon: 'assets/icon/reports',
      });
    }

    if (this.AccessObject.IsSuperUser() && this.userHasWriteAccess) {
      this.navRoutes.push(
        {
          title: 'System Administration',
          link: this.routes.SystemAdmin,
          customIcon: true,
          icon: 'assets/icon/systemAdministration',
        },
      );
    }

    if (this.AccessObject.IsSuperUser()) {
      this.navRoutes.push(
        {
          title: 'User Management',
          link: this.routes.UserManagement,
          customIcon: true,
          icon: 'assets/icon/userManagement',
        },
      );
    }

    this.navRoutes.push({
      title: 'Releases',
      link: this.routes.Releases,
      icon: 'new_releases',
    });
  }

  changeRoute(url: any) {
    this.navigationService.Navigate(url);
    this.dialogRef.close();
  }
}
